import ConfirmationDialog from '../../../core-components/theme/components/DialogBox/ConfirmationDialog';
import { DeleteBatchConfigModalProps } from '../types/BatchConfigType';
import { useDeleteBatchConfig } from '../hooks/useDeleteBatchConfig';

export default function DeleteBatchConfigModal({
  handleClose,
  data,
}: DeleteBatchConfigModalProps) {
  const { actions, handleCancel } = useDeleteBatchConfig(handleClose, data);

  return (
    <ConfirmationDialog
      open={true}
      actions={actions}
      handleClose={handleCancel}
      title="Delete Batch Configuration"
      description="This will be removed from all places it’s used. Are you sure you want to delete it?"
    />
  );
}
